import produce from "immer";
import { compact, without } from "lodash";
import create from "zustand";
import { persist } from "zustand/middleware";
import { getSmartLabelFromKey } from "../context/filteredList/FilteredListProvider";
import { LabelsMap } from "../context/labels/LabelsProvider";
import { Entity } from "./constants";

export enum LabelFilterKey {
  mapHotspotMakers = "mapHotspotMakers",
  mapHotspots = "mapHotspots",
  mapHexes = "mapHexes",
  mapLocations = "mapLocations",
  mapContacts = "mapContacts",
  mapInstalls = "mapInstalls",
  workspaceWallets = "workspaceWallets",
  workspaceDashboardHotspots = "workspaceDashboardHotspots",
  workspaceHotspots = "workspaceHotspots",
  workspaceLocations = "workspaceLocations",
  workspaceInstalls = "workspaceInstalls",
  workspaceContacts = "workspaceContacts",
  workspacePayments = "workspacePayments",
  contactCommissions = "contactCommissions"
}

type FilteredLabelsState = {
  filteredLabels: {
    [key in keyof typeof LabelFilterKey]: string[];
  };
  toggleFilteredLabel: (key: LabelFilterKey, labelUuid: string) => void;
};

const useFilteredLabels = create<FilteredLabelsState>(
  persist(
    (set, get) => ({
      filteredLabels: {
        [LabelFilterKey.mapHotspotMakers]: [],
        [LabelFilterKey.mapHotspots]: [],
        [LabelFilterKey.mapHexes]: ["resolution 7"],
        [LabelFilterKey.mapLocations]: [],
        [LabelFilterKey.mapContacts]: [],
        [LabelFilterKey.mapInstalls]: [],
        [LabelFilterKey.workspaceWallets]: [],
        [LabelFilterKey.workspaceDashboardHotspots]: [],
        [LabelFilterKey.workspaceHotspots]: [],
        [LabelFilterKey.workspaceLocations]: [],
        [LabelFilterKey.workspaceInstalls]: [],
        [LabelFilterKey.workspaceContacts]: [],
        [LabelFilterKey.workspacePayments]: [],
        [LabelFilterKey.contactCommissions]: []
      },
      toggleFilteredLabel: (key, labelUuid) =>
        set((state) =>
          produce(state, (draft) => {
            const labelIndex = draft.filteredLabels[key].findIndex(
              (x) => x === labelUuid
            );

            if (labelIndex > -1) {
              draft.filteredLabels[key] = without(
                draft.filteredLabels[key],
                labelUuid
              );
            } else {
              draft.filteredLabels[key].push(labelUuid);
            }
          })
        )
    }),
    {
      name: "filtered_labels",
      getStorage: () => sessionStorage
    }
  )
);

export default useFilteredLabels;

//
// Utils
//

export const getFilteredLabels = (
  filteredLabelUuids: string[],
  labelsMap: LabelsMap,
  smartLabelFilters: {
    [key: string]: (item: any) => boolean;
  },
  entity: Entity
) =>
  compact(
    filteredLabelUuids &&
      filteredLabelUuids.map(
        (labelUuid) =>
          labelsMap[labelUuid] ||
          (smartLabelFilters[labelUuid] != null &&
            getSmartLabelFromKey(labelUuid, entity))
      )
  );
